import { Avatar, Button, Divider } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import firebase_ from '../../../firebase/firebase';
import './AnswerPage.css'
import HelpIcon from '@material-ui/icons/HelpOutline'
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
function AnswerPage(props) {

    const [questionDetails, setQuestionDetails] = useState([0])
    const [answers, setAnswers] = useState([0])
    const [answerLoad, setAnswerLoad] = useState(false)
    const [questionFlag, setQuestionFlag] = useState(false)
    const [answerInput, setAnswerInput] = useState('')
    const [inputFile, setInputFile] = useState(null)

    const db = firebase_.firestore()
    const storage = firebase_.storage()

    useEffect(async (e) => {
        console.log('hey');
        try {
            await db.collection('Questions').doc(props.match.params.id).get()
                .then(async res => {
                    console.log('response', await res.data());
                    // setQuestionDetails(await res.data())
                    var data = await res.data()
                    console.log('data :', res.data());
                    setQuestionDetails(await res.data())
                    // questionDetails.push(await res.data())
                    setAnswers(await res.data()['answers'])
                    var answers_ = data['answers']

                    if (answers_.length > 0) {
                        setAnswerLoad(true)
                        setQuestionFlag(true)
                    }

                    console.log('>>', questionDetails);
                })
        } catch (err) {
            console.log('error in fetching question details ', err);
        }
        finally {
            console.log('--', answers)
        }

    }, [])
    const handleChange = (e) => {
        if (e.target.name === "answerInput") {
            setAnswerInput(e.target.value)
        }
    }
    const handleChangeFile = (e) => {
        setInputFile(e.target.files[0])

    }
    const handleSubmit = (e) => {
        e.preventDefault()
        console.log('answer');
        if (inputFile != null) {
            var storageRef = storage.ref();
            var spaceRef = storageRef.child(`images/${inputFile['name']}`)


            spaceRef.put(inputFile)
                .then(async res => {

                    answers.push({
                        "answer": answerInput,
                        "answerBy": [{
                            "userName": sessionStorage.getItem('userName'),
                            "emailId": sessionStorage.getItem('emailId'),
                            "profileImageUrl": sessionStorage.getItem('imgUrl')
                        }],
                        "imgUrl": await spaceRef.getDownloadURL()
                    })

                    db.collection('Questions').doc(props.match.params.id).update({
                        "answers": answers,

                    }).then(res => {
                        console.log('success');
                        window.location.reload()
                    })
                        .catch(err => {
                            console.log('error', err);
                        })
                }).catch(err => {
                    console.log('error in answer image uploading ', err);
                })
        } else {
            answers.push({
                "answer": answerInput,
                "answerBy": [{
                    "userName": sessionStorage.getItem('userName'),
                    "emailId": sessionStorage.getItem('emailId'),
                    "profileImageUrl": sessionStorage.getItem('imgUrl')
                }],
                "imgUrl": ""
            })
            db.collection('Questions').doc(props.match.params.id).update({
                "answers": answers,

            }).then(res => {
                console.log('success');
                window.location.reload()
            })
                .catch(err => {
                    console.log('error', err);
                })
        }



    }
    return (
        <div>
            <div className="answer-outer-card">
                <div className="question-details-card">

                    {answerLoad ?
                        <div>
                            <h1><HelpIcon />{questionDetails['question']}</h1>
                            <div style={{ display: 'flex', justifyContent: 'stretch' }}>
                                <Avatar src={questionDetails['askedBy'][0]['profileImageUrl']} />
                                <p style={{ marginLeft: '2%' }}>{questionDetails['askedBy'][0]['userName']}</p>
                                <p style={{ marginLeft: '2%' }}>#{questionDetails['technology']}</p>

                            </div>
                            <a href={questionDetails['imgUrl']} target="_blank">
                                <img src={questionDetails['imgUrl']} style={{ width: '50%' }} />
                            </a>
                        </div> :
                        <div>Loading</div>}

                </div>
                {/* <h1 style={{textAlign:'center'}}>Solutions</h1> */}
                <Divider />
                <div>
                    {answerLoad ?
                        <div className="answer-list">
                            {answers.map((element, index) => {
                                if (element['answer'] === "") {
                                    return (
                                        <div></div>
                                    )
                                } else {
                                    return (
                                        <div className="answer-list-item">
                                            <div style={{ display: "flex" }}>
                                                <ArrowRightIcon style={{ marginTop: '2%' }} />
                                                <div >
                                                    <h3> {element['answer']}</h3>
                                                    <div style={{ display: 'flex',width:'200%' }}>
                                                        <Avatar src={element['answerBy'][0]['profileImageUrl']} />

                                                        <p style={{marginLeft:'5%'}}>{element['answerBy'][0]['userName']} </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <a href={element['imgUrl']} target="_blank">
                                                <img src={element['imgUrl']} style={{ width: '50%' }} />

                                            </a>
                                            <Divider />
                                        </div>
                                    )
                                }
                            })}
                        </div> :
                        <div>
                            Loading
                        </div>}
                    <div className="answer-input-section">
                        <input className="answer-input" onChange={handleChange} placeholder="Answer here " name="answerInput" />
                        <input className="attach-img" onChange={handleChangeFile} type="file" name="inputFile" />

                        <Button onClick={handleSubmit} className="answer-btn">Submit</Button>
                    </div>

                </div>
            </div>

        </div>
    );
}

export default AnswerPage;